import React from "react";

import HistoryItem from "./HistoryItem";

import type { SearchHistoryItem } from "./types";

const HistorySection = ({
  title,
  items,
  onItemClick,
  hasSearchQuery,
  searchQuery,
}: HistorySectionProps) => {
  if (items.length === 0) return null;

  return (
    <div className="mb-6">
      <h3 className="text-sm font-semibold mb-3 text-gray-700 dark:text-gray-300">
        {title}
      </h3>
      <div className="space-y-2">
        {items.map((item) => (
          <HistoryItem
            key={item.id}
            item={item}
            onClick={onItemClick}
            hasSearchQuery={hasSearchQuery}
            searchQuery={searchQuery}
          />
        ))}
      </div>
    </div>
  );
};

type HistorySectionProps = {
  title: string;
  items: SearchHistoryItem[];
  onItemClick: (item: SearchHistoryItem) => void;
  hasSearchQuery?: boolean;
  searchQuery?: string;
};

export default HistorySection;
